import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { NgBsToastService } from 'ng-bs-toast-service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-recover-password',
    standalone: false,
    templateUrl: './recover-password.component.html',
})
export class RecoverPasswordComponent implements OnInit {

    loading: boolean;

    constructor(
        private authService: AuthService,
        private toastService: NgBsToastService,
        private router: Router,
    ) { }

    ngOnInit() {
        if (this.authService.token && this.authService.token.hash)
            this.router.navigate(['/']);
    }

    onSubmit(form: NgForm) {
        this.loading = true;
        this.authService.recoverPassword(form.value.email).subscribe({
            next: () => {
                this.toastService.send('Sucesso', 'Email de recuperação enviado!', 'success');
                this.router.navigate(['/login']);
            }, error: (err: HttpErrorResponse) => this.toastService.send(`Error ${err.status}`, err.error.error || err.name, 'danger')
        }).add(() => this.loading = false);
    }

}
